import React from 'react';

import Icon from 'presentation/icons';

import {StyledOptionIcon} from './styles';
import {OptionIconProps} from './types';

export function OptionIcon({icon, imageSrc}: OptionIconProps) {
	return (
		<StyledOptionIcon>
			{imageSrc ? <img src={imageSrc} alt="" /> : null}
			{!imageSrc && icon ? <Icon name={icon} /> : null}
		</StyledOptionIcon>
	);
}
